<template>
  <el-dialog title="逾期申请"
             center
             :visible.sync="dialogVisible">
    <el-form :model="form"
             label-width="80px">
      <el-form-item label="任务名">
        <p>{{form.TASKNAME}}</p>
      </el-form-item>
      <el-form-item label="申请人">
        <el-col :span="8">
          <p>{{form.CREATEUSERNAME}}</p>
        </el-col>
        <el-col :span="4">
          延期时长
        </el-col>
        <el-col :span="8">
          <p>{{form|delayFormater}}</p>
        </el-col>
      </el-form-item>
      <el-form-item label="逾期原因">
        <p>{{form.MEMO}}</p>
        <!-- <el-input type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  v-model="form.MEMO"
                  readonly></el-input>-->
      </el-form-item>
      <el-form-item label="延长时长">
        <el-col :span="11">
          <el-input-number v-model="form.APPROVALDELAYNUM"
                           :min="1"></el-input-number>
        </el-col>
        <el-col :span="11">
          <el-select v-model="form.APPROVALDELAYUNIT"
                     placeholder="请选择">
            <el-option label="分钟"
                       value="0"> </el-option>
            <el-option label="小时"
                       value="1"> </el-option>
            <el-option label="天"
                       value="2"> </el-option>
          </el-select>
        </el-col>
      </el-form-item>
      <!--  <el-form-item label="是否通过">
        <el-col :span="24">
          <el-radio-group v-model="form.ISAPPROVAL">
            <el-radio label="true">通过</el-radio>
            <el-radio label="false">拒绝</el-radio>
          </el-radio-group>
        </el-col>
      </el-form-item>-->
      <el-form-item label="审批描述">
        <el-input type="textarea"
                  :autosize="{ minRows: 2, maxRows: 4}"
                  v-model="form.APPROVALMEMO"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="approveDelay(true)"
                 type="primary">通过</el-button>
      <el-button @click="approveDelay(false)">不通过</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getToken } from "../../../util/auth";
import { ApprovalTaskDelay } from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  data() {
    return {
      dialogVisible: false,
      form: {
        TASKNAME: "",
        ISAPPROVE: true,
        APPROVALMEMO: "",
        DELAYUNIT: "1",
        DELAYNUM: 0,
        CREATEUSERNAME: "",
        MEMO: "",
        APPROVALDELAYNUM: 1,
        APPROVALDELAYUNIT: "1"
      }
    };
  },
  filters: {
    delayFormater: function(value) {
      let delayTimeName = "";
      switch (value.DELAYUNIT) {
        case "0":
          delayTimeName = value.DELAYNUM + "分钟";
          break;
        case "1":
          delayTimeName = value.DELAYNUM + "小时";
          break;
        case "2":
          delayTimeName = value.DELAYNUM + "天";
          break;
        default:
          break;
      }
      return delayTimeName;
    }
  },
  methods: {
    //加载延期信息
    loadDelayInfo(info) {
      this.form = {
        TASKNAME: "",
        ISAPPROVE: true,
        APPROVALMEMO: "",
        DELAYUNIT: "1",
        DELAYNUM: 0,
        CREATEUSERNAME: "",
        MEMO: "",
        APPROVALDELAYNUM: 1,
        APPROVALDELAYUNIT: "1"
      };
      this.form = info;
      this.form.DELAYUNIT = this.form.DELAYUNIT.toString();
      this.form.APPROVALDELAYNUM = this.form.DELAYNUM;
      this.form.APPROVALDELAYUNIT = this.form.DELAYUNIT;
      this.dialogVisible = true;
    },
    approveDelay(istrue) {
      if (this.form) {
        let delayTime = new Date();
        var t_s = delayTime.getTime();
        switch (this.form.APPROVALDELAYUNIT) {
          case "0":
            delayTime.setTime(t_s + 1000 * 60 * this.form.APPROVALDELAYNUM);
            break;
          case "1":
            delayTime.setTime(
              t_s + 1000 * 60 * 60 * this.form.APPROVALDELAYNUM
            );
            break;
          case "2":
            delayTime.setTime(
              t_s + 1000 * 60 * 60 * 24 * this.form.APPROVALDELAYNUM
            );
            break;
        }
        this.form.APPROVALTIME = this.datetimeFormater(new Date());
        this.form.DELAYTIME = this.datetimeFormater(delayTime);
        let approveInfo = Object.assign(this.form, {});
        approveInfo.ISAPPROVAL = istrue;
        console.log(approveInfo);
        ApprovalTaskDelay(approveInfo).then(result => {
          if (result.ResultCode > 0) {
            this.$emit("refershSource");
            this.$message.success("保存成功");
          } else {
            this.$message.error(result.MsgInfo);
          }
          this.dialogVisible = false;
        });
      }
    },
    datetimeFormater(delayTime) {
      return (
        delayTime.getFullYear() +
        "-" +
        (delayTime.getMonth() + 1) +
        "-" +
        delayTime.getDate() +
        " " +
        delayTime.getHours() +
        ":" +
        delayTime.getMinutes() +
        ":" +
        delayTime.getSeconds() +
        ""
      );
    }
  }
};
</script>

<style lang="scss" scoped>
</style>